/** Google map key */
export const GOOGLE_MAP_KEY = "AIzaSyACVcW7qBPdSi47lId2QL2HQwQzfusHwo0";
export const FIXED_AVAILABLE_BADGE_ID = "600ab6e5e503271f1c8ebcd0";
export const FIXED_RESERVED_BADGE_ID = "6012c054b88dc494783275c5";